import React, { useEffect, useMemo, useState } from 'react';
import { Container } from 'reactstrap';
import Badge from "react-bootstrap/Badge";
import CancellationDetailsView from './components/RecallDetailsView';
import PndRestApi from 'src/utils/pnd/PndRestApi';
import { LinearProgress, SnackbarContent, Tooltip } from '@mui/material';
import { ERROR_MESSAGES, OPERATION_TYPE_FOR_ORDER_RECALL } from '../../../../utils/pnd/PndConstants';
import CancelPresentationRoundedIcon from '@mui/icons-material/CancelPresentationRounded';
import ConfirmationDialog from "src/shared/components/ConfirmationDialog";
import { showNotification, successNofication } from 'src/shared/components/Notification';
import { Redirect } from 'react-router-dom';

const OrderRecallDetailsIndex = () => {
  useEffect(() => {
    getAllOrderDetails();

  }, [])

  const [reactTableData, setReactTableData] = useState([]);
  const [temp, setTempData] = useState("");
  const [loading, setLoading] = useState(false);
  const [isNoRecordFound, setNoRecordFound] = useState(false);
  const [isRedirect, setRedirect] = useState(false);
  const [isOrderId, setOrderId] = useState(null);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [isOperationType, setOperationType] = useState(null);
  const getAllOrderDetails = async () => {
    try {
      setLoading(true);
      let Obj = {};

      Obj["operationType"] = OPERATION_TYPE_FOR_ORDER_RECALL;
      //Obj["orderType"] = OPERATION_TYPE_FOR_CANCELLED;
      Obj["isCancellation"] = true;
      const response = await PndRestApi.GetAllOrders(Obj);
      if (response.status === 200 && response.data.status === 200) {
        setReactTableData({ tableHeaderData: columns, tableRowsData: response.data.data });
      } else if (response?.data?.status && response?.data?.status === 204) {
        setNoRecordFound(true);
      } else {
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: ${response.data.status}`,
          `Message:${response.data.message}`,
        );
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      showNotification(
        "theme-light",
        "ltr",
        `SuccessCode: 500`,
        ERROR_MESSAGES.tryCatchError,
      );
    } finally {
      setLoading(false);
    }
  };


  const columns = useMemo(
    () => [
      {
        Header: '#',
        accessor: (row, i) => i + 1, // Or just use Cell below for more control
        disableGlobalFilter: true,
        disableSortBy: true,
        width: 65,
        Cell: ({ row }) => row.index + 1, // <-- This sets the serial number based on row index
      },
      {
        Header: 'Tracking No.',
        accessor: 'orderNumber',
        disableGlobalFilter: false,
      },
      {
        Header: 'Invoice No.',
        accessor: 'invoiceNo',
        disableGlobalFilter: true,
      },
      // {
      //   Header: 'Ecom Order No.',
      //   accessor: 'salesOrderNo',
      //   disableGlobalFilter: false,
      // },
      {
        Header: "Order Type",
        accessor: "orderType",
        disableSortBy: false,
        Cell: ({ row }) => (
          <>
            {row.original.orderType === 1 ? (
              <h6><Badge bg="success">DO</Badge></h6>
            ) : row.original.orderType === 2 ? (
              <h6><Badge bg="primary">PU</Badge></h6>
            ) : (
              <h6><Badge bg="warning">PnD</Badge></h6>
            )}
          </>
        )
      },
      {
        Header: "Order From",
        accessor: "fromTypeId",
        disableSortBy: false,

        Cell: ({ row }) => (
          <>
            {row.original.fromTypeId === 1 ? (
              <h6><Badge bg={"success"}>OH</Badge></h6>
            ) : row.original.fromTypeId === 2 ? (
              <h6><Badge bg={"success"}>HC</Badge></h6>
            ) : row.original.fromTypeId === 3 ? (
              <h6><Badge bg={"success"}>M</Badge></h6>
            ) : row.original.fromTypeId === 4 ? (
              <h6><Badge bg="success">AH</Badge></h6>
            ) : <h6><Badge bg="success">MC</Badge></h6>}
          </>
        )
      },
      {
        Header: "From Customer",
        accessor: "fromName",
        disableGlobalFilter: false,

      },
      {
        Header: "Order To",
        accessor: "toTypeId",
        disableSortBy: false,
        Cell: ({ row }) => (
          <>
            {row.original.toTypeId === 1 ? (
              <h6><Badge bg="success">OH</Badge></h6>
            ) : row.original.toTypeId === 2 ? (
              <h6><Badge bg="success">HC</Badge></h6>
            ) : row.original.toTypeId === 3 ? (
              <h6><Badge bg="success">M</Badge></h6>
            ) : row.original.toTypeId === 4 ? (
              <h6><Badge bg="success">AH</Badge></h6>
            ) : <h6><Badge bg="success">MC</Badge></h6>}
          </>
        )
      }, ,

      {
        Header: "To Customer",
        accessor: "toName",
        disableGlobalFilter: false,
      },
      // {
      //   Header: 'From Address',
      //   accessor: 'pickupAddress',
      //   disableGlobalFilter: false,
      // },
      // {
      //   Header: 'To Address',
      //   accessor: 'dropOffAddress',
      //   disableGlobalFilter: false,
      // },


      {
        Header: "Order Status",
        accessor: "orderStatus",
      },

      {
        Header: 'Requested From',
        accessor: 'orderCancellationRequestedFrom',
        Cell: ({ row }) => (
          <><div className="icon-style" >
            {row.original?.orderCancellationRequestedFrom == 2 ? (
              <h6><Badge bg="warning">Merchant</Badge></h6>)
              : "Own Hub"
            }
          </div ></>
        ),
      },

      {
        Header: 'Action',
        accessor: 'edit',
        disableSortBy: true,
        Cell: ({ row }) => (
          <><div className="icon-style" >
            {
              (<Tooltip title="Click here to Recall the Order Details">
                <CancelPresentationRoundedIcon style={{ cursor: "pointer", color: "red" }} onClick={() => showDialogBox(row.original, OPERATION_TYPE_FOR_ORDER_RECALL)} />
              </Tooltip>)
            }
          </div ></>
        ),
      },
    ],
    [],
  );

  const closeDialog = () => {
    // Close confirmation dialog without performing unassignment
    setShowConfirmation(false);
  };


  const showDialogBox = async (event, operationType) => {
    setOperationType(operationType);
    setShowConfirmation(true);
    if (event?.orderId) {
      setTempData(event);
      setOrderId(event?.orderId);

    }
  }


  const processOrder = async (event) => {
    try {
      if (event) {
        setOrderId(event?.orderId);
      }
      setLoading(true);
      setShowConfirmation(false);
      let Obj = {};
      Obj["operationType"] = isOperationType;
      Obj["orderId"] = isOrderId;


      const response = await PndRestApi.UpdateOrderStatusDetails(Obj);
      if (response.status === 200 && response.data.status === 200) {
        successNofication(
          "theme-light",
          "ltr",
          `Message: Order Status Updated Successfully`
        );
        setRedirect(true);
      } else {
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: ${response.data.status}`,
          `Message:${response.data.message}`,
        );
        return;
      }

    } catch (error) {
      console.error('Error fetching data:', error);
      showNotification(
        "theme-light",
        "ltr",
        `SuccessCode: 500`,
        ERROR_MESSAGES.tryCatchError,
      );
    } finally {
      setLoading(false);
    }


  }
  if (isRedirect) {
    return <Redirect to={`/web_app/pnd_order/merchant/order_recall`} />;
  }


  return (
    <Container>
      {(reactTableData && reactTableData != null && reactTableData.tableRowsData != null) &&
        <CancellationDetailsView reactTableData={reactTableData} />}
      {loading && <LinearProgress color="primary" />} {/* Display progress bar while loading */}
      {isNoRecordFound && <CancellationDetailsView isNoRecordFound={isNoRecordFound} />}
      {isNoRecordFound && <SnackbarContent message={"No Record Found"} />}




      {
        showConfirmation && (
          <ConfirmationDialog
            open={showConfirmation}
            onClose={closeDialog}
            onConfirm={() => processOrder(temp)} // Pass the temp data to assignOrder
            title="Confirmation"
            message="Do you want to Recall the Order?"
          />
        )
      }
    </Container>
  );
};

export default OrderRecallDetailsIndex;